import React from "react";
import { CSSProperties } from "styled-components";

const SvgBack = (props: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="675"
			height="100"
			viewBox="0 0 675 100"
			fill="none"
			preserveAspectRatio="xMaxYMid meet"
			style={props.style}
		>
			<g filter="url(#filter0_d_32937_28191)">
				<path
					d="M-259 0H675L641.154 81.2308C637.427 90.1743 628.689 96 619 96H-259V0Z"
					fill="white"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_32937_28191"
					x="-262"
					y="-2"
					width="940"
					height="102"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="1" />
					<feGaussianBlur stdDeviation="1.5" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_32937_28191"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_32937_28191"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
export default SvgBack;
export interface Props {
	style?: React.CSSProperties;
}
